/// <amd-module name="Artifacts/Nuget/NuGetProtocolMetadata" />
export interface INuGetProtocolMetadata {
  copyright: string;
  iconUrl: string;
  iconFile: string;
  licenseUrl: string;
  licenseExpression: string;
  licenseFile: string;
  language: string;
  minClientVersion: string;
  projectUrl: string;
  releaseNotes: string;
  requireLicenseAcceptance: string;
  title: string;
}
